import { render, staticRenderFns } from "./BostonLayout.vue?vue&type=template&id=655c2850"
import script from "./BostonLayout.vue?vue&type=script&lang=js"
export * from "./BostonLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports